import React, { useEffect, useState } from 'react';
import { Form, FormikProvider, useFormik } from 'formik';
import { Alert, Autocomplete, Box, Button, Stack, TextField } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useSnackbar } from 'notistack';
import { useSelector } from 'react-redux';
import GlobalDialog from '../../../../../components/mui/Dialogue/GlobalDialog';
import * as Yup from 'yup';
import { getDataForCrdAdmissionRegister, updateForecast } from '../../../../../redux/features/CRDslice';
import { Icon } from '@iconify/react/dist/iconify.js';
import GlobalSelectField from '../../../../../components/mui/GlobalSelectField';

const UpdateForecast = ({ row, dispatchParams, apiCall }) => {
  const [open, setOpen] = useState(false);

  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const { loading } = useSelector((state) => state.crd);

  const validationSchema = Yup.object().shape({
    reason: Yup.string().trim().required('Reason is required'),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      course_enrollment_id: row?.course_enrollment_id || null,
      reason: '',
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      dispatch(updateForecast(values)).then((res) => {
        if (res.payload.status === 'success') {
          enqueueSnackbar(res.payload.message, {
            variant: 'success',
          });
          if (apiCall) {
            dispatch(apiCall(dispatchParams));
          } else {
            dispatch(getDataForCrdAdmissionRegister(dispatchParams));
          }
          setOpen(false);
          formik.resetForm();
        } else {
          enqueueSnackbar(res.payload.message, {
            variant: 'error',
          });
          formik.resetForm();
          // setOpen(false);
        }
      });
    },
  });

  return (
    <GlobalDialog
      title={'Forecast Break'}
      open={open}
      setOpen={setOpen}
      fullWidth
      maxWidth={'xs'}
      closeButton={true}
      popupButton={
        <Button
          variant="outlined"
          color="secondary"
          size="medium"
          startIcon={<Icon width={20} height={20} icon={'fa7-solid:money-bill-trend-up'} />}
          onClick={() => setOpen(true)}
        >
          Forecast Break
        </Button>
      }
      content={
        <>
          <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
              <Box>
                <Stack direction={'column'} spacing={2}>
                  {row?.cart_item_selected_option === null && (
                    <Alert variant="outlined" severity="info">
                      The forecast method is already set to manual. You cannot switch back to system forecasting.
                    </Alert>
                  )}
                </Stack>
                {row?.cart_item_selected_option !== null && (
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'flex-end',
                      gap: 2,
                      justifyContent: 'flex-end',
                      flexDirection: 'column',
                    }}
                  >
                    <Box>
                      <Alert variant="filled" severity="info">
                        You are trying to change system forecast to manual forecast. Once confirmed, You cannot switch
                        back to system forecasting
                      </Alert>
                    </Box>
                    <TextField
                      fullWidth
                      multiline
                      rows={3}
                      label="Reason"
                      name="reason"
                      value={formik.values.reason}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={Boolean(formik.touched.reason && formik.errors.reason)}
                      helperText={formik.touched.reason && formik.errors.reason}
                    />
                    <Stack direction={'row'} spacing={1}>
                      <Button size="small" variant="outlined" color="info" onClick={() => setOpen(false)}>
                        Cancel
                      </Button>
                      <Button
                        disabled={loading || !formik.values.reason?.trim()}
                        variant="contained"
                        color="info"
                        size="small"
                        type="submit"
                      >
                        {loading ? 'Please wait...' : 'Confirm'}
                      </Button>
                    </Stack>
                  </Box>
                )}
              </Box>
            </Form>
          </FormikProvider>
        </>
      }
    />
  );
};

export default UpdateForecast;
